import React, { Component } from 'react';
import { connect } from 'react-redux';
import { gameActions } from '../../action/GameAction';
import Header from '../../Header/Header';
import { alertActions } from '../../action/AlertAction';
import { withTranslation } from 'react-i18next';
import Countdown, { zeroPad } from 'react-countdown';
import { history } from '../../helpers/history';
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
import { appVariables } from '../../helpers/appVariables';
import SaleClose from '../SaleClosed/SaleClose';
import HomeSlidTabs from '../Home/HomeSlidTabs';
import PriceBreakdown from '../Home/PriceBreakdown';
import Footer from '../../Footer/Footer';
import LatestResults from '../Home/LatestResults';
import Home from '../Home/Home';
import LoadHomeLotto from './LoadHomeLotto';
import HowToPlay from '../Home/HowToPlay';
import Aboutplaylotto from './Aboutplaylotto';
import Aboutminilotto from './Aboutminilotto';
import Aboutfastlotto from './Aboutfastlotto';
import Aboutmillionairelotto from './Aboutmillionairelotto';
import Aboutmultimillion from './Aboutmultimillion';
import Aboutsupermega from './Aboutsupermega';
import LoadFaqsLotto from './LoadFaqsLotto';
import LottoHelmetOthers from '../Helmet/LottoHelmetOthers';

let refecthgamecnt = 0;
let refecthgameallcnt = 1;
const locky1Arr = [1, 2, 5, 10];
let regameRefetch = null;
let lastCountDownTime = Date.now();
class Lotto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDrawCompleted: false,
            cartItems: [],
            padCount: 0,//default pad count
            padCountmax: 31,//max pad count
            lottoType: props.lottotype, //9-fortune5, 10-super6
            random: [],
            myfavNoID: 0,
            otherGameCount: 0,
            OldcartItems: [],
            datafatchCompleted: false,
            CartmaxLength: 50,
            showSaleCloseInfo: false,
            myUCDraw: [],
            ShowSelectNumbers: []
        };
        const did = localStorage.getItem('lid');
        //props.ClearCart();
        props.closeBetSlip();
        let tmr = setInterval(
            () => {
                if (this.props.serverTime && this.props.serverTime > 0) {
                    clearInterval(tmr);
                    props.GameAvailableGames(props.user.mobileNo, this.state.lottoType, props.i18n.language, this.props.serverTime, this.props.user.loginKey);
                    if (props.user.mobileNo != 0) {
                        props.GetMyFavNumbers(this.state.lottoType, props.user.mobileNo, props.i18n.language, this.props.user.loginKey);
                    }
                }
            }
            , 1000)
    }

    static getDerivedStateFromProps(props, state) {
        return {
            currentAvailableDraws: props.currentAvailableDraws, // game loading performance changes.
            currentDraw: props.currentDraw,
            MyFavNos: props.MyFavNos,
        }
    }
    componentDidMount() {
        setTimeout(() => {
            if (this.state.currentDraw && Object.keys(this.state.currentDraw).length > 0 && this.state.datafatchCompleted == false) {
                this.state.datafatchCompleted = true;
            }
        }, 1000); //5000

        let Timeinntervl = setInterval(() => {
            if (this.state.currentAvailableDraws && this.state.currentAvailableDraws.filter(a => a.gamegroupID == this.state.lottoType && a.SaleStatus != 1).length <= 1 && this.state.lottoType == 13 && refecthgameallcnt < 3) {
                this.reloadNextDraw();
                if (this.state.currentAvailableDraws.filter(a => a.gamegroupID == this.state.lottoType && a.SaleStatus != 1).length > 0) {
                    clearInterval(Timeinntervl);
                }
            }
            else {
                clearInterval(Timeinntervl);
            }
            refecthgameallcnt++;
        }, 1500 * refecthgameallcnt);
        //let mythis = this;
        // window.addEventListener("visibilitychange", function () { mythis.handleFocus(); })
    };
    handleFocus = () => {
        try {
            if (document.visibilityState == "visible") {
                console.log("lastCountDownTime", lastCountDownTime)
                let newCountDownTime = Date.now();
                let diffCountDownTime = newCountDownTime - lastCountDownTime
                console.log('diffCountDownTime', diffCountDownTime)
                if (diffCountDownTime > 300000) { //time difference in 5min (300000)           
                    window.location.reload();
                }
            }
        }
        catch (ex) {
            console.log("document visibilityState", ex)
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentDraw && Object.keys(this.state.currentDraw).length > 0 && this.state.currentDraw.SaleStatus == 0 && this.state.datafatchCompleted == false) {
            this.state.datafatchCompleted = true;
            // this.createGamepad(this.state.padCount);
            this.LoadReBetNumber();
            this.loadPrevCartItem();
            this.loadSelectFavNo();
            let cobj = {};
            let Cdraw = [this.state.currentDraw];
            commonClass.SendEventTracking(11, cobj, false, Cdraw);
        }
        else {
            this.reFetchTheGameData(1); // game loading performance changes.
        }
        //default draw selection issue solved
        if (this.state.currentDraw && this.state.currentDraw.gamegroupID == 13 && this.state.currentDraw.SaleStatus == 0) {
            if (!this.state.myUCDraw || this.state.myUCDraw.length == 0) {
                this.state.myUCDraw = [this.state.currentDraw.GameId];
            }
        }
    }
    reFetchTheGameData = (fromdidupdate) => {
        if (this.state.datafatchCompleted == false) {
            if ((!this.state.currentDraw || (Object.keys(this.state.currentDraw).length == 0) || this.state.currentDraw.SaleStatus == 1) && refecthgamecnt < 5) {
                if (regameRefetch == null) {
                    console.log("refecthgamecnt " + refecthgamecnt);
                    let mythis = this;
                    refecthgamecnt++;
                    regameRefetch = setInterval(() => { 
                        debugger
                        mythis.props.GameAvailableGames(mythis.props.user.mobileNo, this.state.lottoType, mythis.props.i18n.language, mythis.props.serverTime, mythis.props.user.loginKey);
                        clearInterval(regameRefetch);
                        regameRefetch = null;
                    }, (1000 * refecthgamecnt));
                }
            }
            else {
                if (fromdidupdate != 1) {
                    this.state.datafatchCompleted = true;
                    this.setState({ datafatchCompleted: true });
                }
            }
        }
    };
    createGamepad = (addpadcount) => {
        if (this.state.currentDraw && Object.keys(this.state.currentDraw).length > 0) {
            if (addpadcount > 0) {
                let _draw = this.state.currentDraw;
                for (let i = 1; i <= addpadcount; i++) {
                    let tarr = []
                    for (let i = 1; i <= _draw.no_of_balls.split('~')[2]; i++) {
                        tarr.push('?');
                    }
                    //_maxid++;
                    const min = 0;
                    const max = 99999;
                    let _maxid = min + (Math.random() * (max - min));
                    let mybet = {
                        GamePadId: _maxid, BetSelection: tarr, stakeValue: 0, GameId: _draw.GameId,
                        RateInPs: _draw.RateInPs, gamegroupID: _draw.gamegroupID, StakeMulti: _draw.StakeMulti,
                        total: (_draw.minStake * _draw.RateInPs), no_of_balls: _draw.no_of_balls,
                        LotName: _draw.LotName, DrawDateTime: _draw.DrawDateTime, DrawTime: _draw.DrawTime,
                        minStake: _draw.minStake, maxStake: _draw.maxStake, betComplete: false, DrawShowTime: _draw.DrawDate + " " + _draw.DrawShowTime,
                        SaleCloseTimeMSec: _draw.SaleCloseTimeMSec, OddsVal: (_draw.gamegroupID == 13 ? 1 : 0)
                    };
                    this.state.cartItems.push(mybet)
                }
            }
            else {
                let dd = this.state.cartItems.pop();
                for (let i = 1; i < Math.abs(addpadcount); i++) {
                    this.state.cartItems.pop();
                }
                this.state.cartItems[this.state.cartItems.length - 1] = dd;
            }
        }
    }
    showMsg = (msg, flag) => {
        this.props.alertError(this.props.t(msg), flag);
    }
    createBall = (x) => {
        if (x.SaleStatus == 1) {
            return <></>;
        }
        let darr = x.no_of_balls.split('~');
        let GameId = x.GameId;
        // let sballno = darr[0];
        // let eballno = darr[1];
        let sballno = parseInt(darr[0]);
        let eballno = parseInt(darr[1]);
        let ballLst = [];
        for (let i = sballno; eballno >= i; i++) {
            //i = ("0" + i).slice(-2);
            let b = "" + i;
            let b_i = GameId + "_" + b;
            ballLst.push(<li id={`ball_${b_i}`} onClick={() => { this.selectBall(i, x) }}>
                <div className={`${x.BetSelection.filter(y => y == i).length > 0 ? `lottoBall lto-${x.gamegroupID}-border lto-${x.gamegroupID}-active` : `lottoBall lto-${x.gamegroupID}-border`}`}>{i}
                </div></li>)
        }
        return ballLst;
    }

    selectBall = (b_id, x) => {
        let flst = x.BetSelection.filter(a => a == b_id);
        let darr = x.no_of_balls.split('~')[2];
        if (flst.length > 0) {
            for (let inx = 0; inx < x.BetSelection.length; inx++) {
                if (x.BetSelection[inx] == b_id) {
                    x.BetSelection[inx] = '?';
                    x.BetSelectionSort = '' // qucik pick selection duplicate number issue.
                    break;
                }
            };
            //x.BetSelection = x.BetSelection.filter(a => (a != b_id));
        }
        else {
            if (x.BetSelection.filter(a => a != '?').length >= darr) {
                this.props.alertError(this.props.t("lblMaxSelect") + darr + '.');
                // alert(this.props.t('lblMaxSelect') + darr);
                return;
            }
            else {
                for (let inx = 0; inx < x.BetSelection.length; inx++) {
                    if (x.BetSelection[inx] == "?") {
                        x.BetSelection[inx] = b_id + "";
                        break;
                    }
                };
            }
        }
        if (x.BetSelection.filter(a => a != '?').length == darr) {
            var arr2 = JSON.stringify(x.BetSelection);
            arr2 = JSON.parse(arr2);
            let sbet = [...arr2.sort((a, b) => parseInt(a) > parseInt(b) ? 1 : -1)];
            let jnew = sbet.map((e, c) => e).join(';')
            let noexits = this.state.cartItems.filter(a => a.BetSelectionSort == jnew);
            if (noexits.length <= 0) {
                let prevCartItem = localStorage.getItem('mycart') != '' ? JSON.parse(localStorage.getItem('mycart')) : null;
                if (prevCartItem) {
                    let noexits1 = prevCartItem.filter(a => a.BetSelectionSort == jnew && a.gamegroupID == this.state.lottoType);
                    if (noexits1.length <= 0) {
                        x.BetSelectionSort = jnew;
                        x.stakeValue = x.minStake;
                    }
                    else {
                        for (let inx = 0; inx < x.BetSelection.length; inx++) {
                            if (x.BetSelection[inx] == b_id) {
                                x.BetSelection[inx] = '?';
                                break;
                            }
                        };
                        this.showMsg(this.props.t('lblDuplicateNoSel'));
                        return;
                    }
                }
                else {
                    // x.BetSelectionSort = jnew;
                    // x.stakeValue = x.minStake;
                    let _reupdate = { ...this.state.currentDraw, BetSelectionSort: jnew, stakeValue: x.minStake }
                    this.state.currentDraw = _reupdate;
                    this.setState({ currentDraw: _reupdate })
                }
            }
            else {
                for (let inx = 0; inx < x.BetSelection.length; inx++) {
                    if (x.BetSelection[inx] == b_id) {
                        x.BetSelection[inx] = '?';
                        break;
                    }
                };
                this.showMsg(this.props.t('lblDuplicateNoSel'))
            }
        }
        // else {
        //     x.stakeValue = 0;
        // }
        // for slow ball selection issues fixed
        let s = this.state.cartItems;
        this.setState({ cartItems: s });
        //or gtm data layer fires, 1st time selection 
        let fsel = localStorage.getItem("ftimesel")
        if (x.stakeValue > 0 && (!fsel || fsel.indexOf("~" + x.gamegroupID) < 0)) {
            localStorage.setItem("ftimesel", fsel + "~" + x.gamegroupID)
            if (x.gamegroupID == 9) {
                commonClass.SendPageDataLayer(5);
            }
            else if (x.gamegroupID == 11) {
                commonClass.SendPageDataLayer(17);
            }
            else if (x.gamegroupID == 10) {
                commonClass.SendPageDataLayer(6);
            }
            else if (x.gamegroupID == 13) {
                commonClass.SendPageDataLayer(19);
            }
        }
        if (x.stakeValue > 0) {
            // this.showMsg('lblnumberselsuc'); //Show After Number Select Msg
            let tmr = setInterval(
                () => {
                    this.props.clearAlerts()
                    clearTimeout(tmr);
                }, 2000)
        }
    }


    Addtolocalcart = () => {
        if (this.state.currentDraw.SaleStatus == 1) {
            return  ;
        }
        if (Object.keys(this.state.currentDraw).length > 0) {
            let darr = this.state.currentDraw.no_of_balls.split('~')[2];
            let selectObj = []
            const min = 0;
            const max = 99999;
            let _maxid = min + (Math.random() * (max - min));
            if (this.state.currentDraw.BetSelection.filter(a => a != '?').length == darr) {
                let addGamePadid = { ...this.state.currentDraw, GamePadId: _maxid }
                selectObj.push(addGamePadid)
                let tarr = [];
                for (let i = 1; i <= darr; i++) {
                    tarr.push('?');
                }
                let selectnumbers = this.state.cartItems;
                selectnumbers = ([...selectnumbers, ...selectObj])
                selectnumbers = JSON.parse(JSON.stringify(selectnumbers))
                this.setState({ cartItems: selectnumbers });
                this.state.currentDraw.BetSelection = tarr;
                this.state.currentDraw.BetSelectionSort = []
            }
            else {
                this.showMsg(this.props.t('lblplcurbet'))
            }
        }
    }

    reCount = (rundraw) => {
        if (rundraw == null || Object.keys(rundraw).length == 0) {
            return <></>;
        }
        else {
            if (this.props.serverTime > 0) {
                this.state.coundownStart = 1;
                return <><Countdown now={() => { return (this.props.serverTime); }} date={this.getGameTime(rundraw)} onComplete={this.countdownCompleted} renderer={this.renderer} /> </>;
            }
            else {
                return <>
                    <><div className="timeCont"><div id="hours1">00</div><p>Hours</p></div><span>:</span></>
                    <><div className="timeCont"><div id="minutes1">00</div><p>Minutes</p></div><span>:</span></>
                    <><div className="timeCont"><div id="seconds1">00</div><p>Seconds</p></div></>
                </>
            }
        }
    };

    getGameTime = (rundraw) => {
        lastCountDownTime = Date.now();
        let _date = rundraw ? rundraw.DrawDateTime : "";
        if (_date != undefined && _date != "") {
            var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            let sTime = (new Date(_date.replace(pattern, '$3-$2-$1').replace(/-/g, '/')).getTime());
            //console.log("getGameTime : " + sTime);
            //console.log("DateNow : " + Date.now());
            //if (rundraw.SaleStatus == 0) { ////0-open,1-closed, sale closeTime implemented
            let SaleCloseTime = sTime - rundraw.SaleCloseTimeMSec;
            let SaleStatusRemaining = SaleCloseTime - this.props.serverTime;
            let SalesClo = (SaleStatusRemaining >= 0 ? 0 : 1);
            if (SalesClo != rundraw.SaleStatus) {
                rundraw.SaleStatus = SalesClo;
                if (rundraw.gamegroupID == 13) {
                    setTimeout(() => {
                        this.reloadNextDraw()
                    }, 1500);
                }
            }
            //}
            return sTime;
        }
        else {
            return 0;
        }
    };

    reloadNextDraw = () => {
        refecthgamecnt = 0;
        this.state.datafatchCompleted = false
        this.state.myUCDraw = [];
        this.reFetchTheGameData();
        setTimeout(() => {
            let mythis = this;
            mythis.props.GameAvailableGames(mythis.props.user.mobileNo, 0, mythis.props.i18n.language, mythis.props.serverTime, mythis.props.user.loginKey);
        }, (500));
    }

    renderer = ({ total, days, hours, minutes, seconds, completed }) => {
        let retval
        if (completed) {
            retval = <div className='aftercomplete' >{this.props.t('lblDrawClosed')}</div>;
        } else {
            if (days > 0) {
                retval = <>
                    <><div className="timeCont"><div id="days1">{zeroPad(days)}</div><p>Days</p></div><span>:</span></>
                    <><div className="timeCont"><div id="hours1">{zeroPad(hours)}</div><p>Hours</p></div><span>:</span></>
                    <><div className="timeCont"><div id="minutes1">{zeroPad(minutes)}</div><p>Min</p></div><span>:</span></>
                    <><div className="timeCont"><div id="seconds1">{zeroPad(seconds)}</div><p>Sec</p></div></>
                </>;
            }
            else {
                retval = <>
                    <><div className="timeCont"><div id="hours1">{zeroPad(hours)}</div><p>Hours</p></div><span>:</span></>
                    <><div className="timeCont"><div id="minutes1">{zeroPad(minutes)}</div><p>Min</p></div><span>:</span></>
                    <><div className="timeCont"><div id="seconds1">{zeroPad(seconds)}</div><p>Sec</p></div></>
                </>;
            }
        }
        return retval;
    };
    countdownCompleted = () => {
        //this.RefreshAfterGameClose();        
        this.state.isDrawCompleted = true;
    };

    clearCart = (x) => {
        x.BetSelection.forEach((_bx, inx) => {
            x.BetSelection[inx] = '?';
        });
        this.state.random = [];
        this.setState({ myfavNoID: 0 });
    };

    clearCartAll = (x) => {
        this.state.cartItems = [];
        if (this.state.currentDraw && this.state.cartItems.length == 0) {
            this.createGamepad(this.state.padCount);
        }
        this.setState({ myfavNoID: 0 })
    };

    ballPadGenerate = (flog, cnt) => {
        if (flog == "+") {
            cnt = (cnt ? cnt : 1);
            let MyCartTicket = JSON.parse(localStorage.getItem('mycart'));
            let MyCartCount = MyCartTicket == null ? 0 : MyCartTicket.filter(Obj => Obj.gamegroupID == this.state.lottoType).length
            let MaxTicketCount = this.state.padCountmax - MyCartCount
            if (this.state.cartItems.length + 1 > MaxTicketCount) {
                this.props.alertError(this.props.t('lblMaximumstake'));
            }
            else { this.createGamepad(cnt) }
        }
        else if (flog == "-") {
            cnt = (cnt ? cnt : -1)
            if (this.state.cartItems.length - 1 < this.state.padCount) {
                return
            }
            else { this.createGamepad(cnt) }
        }
    };
    gotoMyCart = () => {
        if (this.state.otherGameCount > 0) {
            history.push('/mycart');
        }
        else {
            this.showMsg('lblCartempty');
        }
    }
    addMyCart = () => {
        if (this.state.currentDraw && this.state.currentDraw.SaleStatus == 1) {
            this.showMsg('lblclosed');
            return;
        }
        let bervalidate = true;
        for (let i = 0; i < this.state.cartItems.length; i++) {
            let x = this.state.cartItems[i];
            // if (i == this.state.cartItems.length - 1) { // to skip last one
            //     continue;
            // }
            let ecnt = x.BetSelection.filter(a => a != '?').length;
            if (ecnt > 0 && ecnt != x.no_of_balls.split('~')[2]) {
                this.showMsg('lblplcurbet');
                bervalidate = false;
            }
        }
        if (bervalidate) {
            if (this.state.otherGameCount < this.state.CartmaxLength) {
                let ccn = this.state.cartItems.filter(x => x.BetSelection.filter(a => a != '?').length > 0)
                if (ccn == 0) {
                    {
                        this.showMsg('lblplcurbet');
                        return;
                    }
                }
                let mycart = null;
                for (let i = 0; i < this.state.cartItems.length; i++) {
                    // if (i == this.state.cartItems.length - 1) { // to skip last one
                    //     continue;
                    // }
                    if (this.state.cartItems[i].BetSelection.filter(a => a == '?').length > 0) {  // to skip uncompleted bet
                        continue;
                    }
                    if (this.state.cartItems[i].OddsVal <= 0 && this.state.cartItems[i].gamegroupID == 13) {
                        continue;
                    }
                    let oitem = this.state.OldcartItems.filter(a => a.GamePadId == this.state.cartItems[i].GamePadId); if (oitem && oitem.length > 0) {
                        this.props.UpdateCartAll(this.state.cartItems[i]);
                        //this.props.AddToCart(this.state.cartItems[i]);
                    }
                    else {
                        if (mycart == null) {
                            mycart = JSON.parse(localStorage.getItem('mycart'));
                        }
                        let item = mycart && mycart.filter(Fobj => Fobj.BetSelectionSort == this.state.cartItems[i].BetSelectionSort && Fobj.gamegroupID == this.state.cartItems[i].gamegroupID).length;
                        if (item == null || item == undefined || item == 0 || this.state.cartItems[i].gamegroupID == 13) {
                            if (this.state.cartItems[i].gamegroupID == 13) {
                                this.state.cartItems[i].stakeValue = this.state.cartItems[i].minStake * this.state.cartItems[i].OddsVal;
                                //multi draw implementation
                                if (this.state.lottoType == 13 && this.state.myUCDraw && this.state.myUCDraw.length == 1) {
                                    let fucd = this.state.myUCDraw.filter(a => a != this.state.cartItems[i].GameId);
                                    if (fucd && fucd.length > 0) {
                                        let _draw = this.state.currentAvailableDraws.filter(a => a.GameId == fucd[0]);
                                        if (_draw && _draw.length > 0) {
                                            _draw = _draw[0];
                                            this.state.cartItems[i].GameId = _draw.GameId;
                                            this.state.cartItems[i].DrawDateTime = _draw.DrawDateTime;
                                            this.state.cartItems[i].DrawTime = _draw.DrawTime;
                                            this.state.cartItems[i].DrawShowTime = _draw.DrawDate + " " + _draw.DrawShowTime;
                                            this.state.cartItems[i].SaleCloseTimeMSec = _draw.SaleCloseTimeMSec;
                                        }
                                    }

                                }
                            }
                            if (this.state.cartItems[i].gamegroupID != 13) {
                                this.props.AddToCart(this.state.cartItems[i]);
                            }
                            else {
                                this.AddCartLucky1(this.state.cartItems[i])
                            }
                            //multi draw implementaion
                            if (this.state.lottoType == 13 && this.state.myUCDraw && this.state.myUCDraw.length > 1) {
                                let fucd = this.state.myUCDraw.filter(a => a != this.state.cartItems[i].GameId);
                                if (fucd && fucd.length > 0) {
                                    let _draw = this.state.currentAvailableDraws.filter(a => a.GameId == fucd[0]);
                                    if (_draw && _draw.length > 0) {
                                        let cartItemsM = { ...this.state.cartItems[i] }
                                        _draw = _draw[0];
                                        let _maxid = 0 + (Math.random() * (99999 - 0));
                                        // cartItemsM.GamePadId = _maxid;
                                        cartItemsM.GameId = _draw.GameId;
                                        cartItemsM.DrawDateTime = _draw.DrawDateTime;
                                        cartItemsM.DrawTime = _draw.DrawTime;
                                        cartItemsM.DrawShowTime = _draw.DrawDate + " " + _draw.DrawShowTime;
                                        cartItemsM.SaleCloseTimeMSec = _draw.SaleCloseTimeMSec;
                                        this.AddCartLucky1(cartItemsM)
                                        // this.props.AddToCart(cartItemsM);
                                    }
                                }

                            }
                        }
                    }
                }
                let cobj = {};
                let tcartitem = this.state.cartItems.filter(Fobj => Fobj.BetSelectionSort != undefined)
                commonClass.SendEventTracking(9, cobj, false, tcartitem);
                let prev_cartItem = [];
                localStorage.setItem('prevCartItem', prev_cartItem);
                this.showMsg('lblAddCartsucss');
                if (this.props.user == undefined || this.props.user.mobileNo == "0") {
                    let mobno = 0;
                    localStorage.setItem('lastloginuser', mobno);
                    setTimeout(() => {
                        this.showMsg('lblPlsLoginOrSignUp', 1);
                    }, 500);
                    bervalidate = false;
                    return;
                }
                else {
                    setTimeout(() => {
                        history.push('/mycart');
                    }, 1000);
                }
            }
            else {
                this.showMsg('lblMaxLen')
            }
        }
    }


    quickPick = (x) => {
        let darr = x.no_of_balls.split('~');
        let sballno = darr[0];
        let eballno = darr[1];
        let maxballno = darr[2];
        this.state.random = [...x.BetSelection.filter(a => a != '?')];
        x.BetSelection.forEach((_bx, inx) => {
            x.BetSelection[inx] = '?';
        });
        this.state.random = [];
        let QPBallCount = maxballno - this.state.random.length;
        if (QPBallCount <= 0) {
            QPBallCount = maxballno;
        }
        for (var k = sballno; k <= QPBallCount; k++) {
            let _bal = this.generateRandomInteger(x);
            this.selectBall(_bal, x);
        }
    }

    AddCartLucky1 = (Obj) => {
        let lcartl = Obj.BetSelection.length;
        for (var j = 0; j <= lcartl - 1; j++) {
            let _maxid = 0 + (Math.random() * (99999 - 0));
            let storecart = { ...Obj };
            storecart.BetSelection = [storecart.BetSelection[j]];
            storecart.GamePadId = _maxid;
            storecart.BetSelectionSort = [storecart.BetSelection[j]];
            this.props.AddToCart(storecart);
        }
    }

    //  Only Increase Odds Value 
    // MultiSetOddsValue = (Obj) => {
    //     let lcartl = Obj.BetSelection.length;
    //     let Existingcart = JSON.parse(localStorage.getItem('mycart'));
    //     Existingcart = Existingcart.filter(fobj => fobj.gamegroupID == Obj.gamegroupID && fobj.GameId == Obj.GameId);
    //     for (var j = 0; j <= lcartl - 1; j++) {
    //         let _maxid = 0 + (Math.random() * (99999 - 0));
    //         let storecart = { ...Obj };
    //         let _stored_inx = null;
    //         let _update_cart = []
    //         Existingcart.forEach((element, inx) => {
    //             if (element.BetSelection.filter(a => a == storecart.BetSelection[j]).length > 0) {
    //                 _stored_inx = inx;
    //             }
    //         });
    //         if (_stored_inx != null) {
    //             _update_cart = Existingcart[_stored_inx];
    //             _update_cart.OddsVal = storecart.OddsVal + _update_cart.OddsVal;
    //             this.props.UpdateCartAll(_update_cart);
    //         }
    //         else {
    //             storecart.BetSelection = [storecart.BetSelection[j]];
    //             storecart.GamePadId = _maxid;
    //             storecart.BetSelectionSort = [storecart.BetSelection[j]];
    //             this.props.AddToCart(storecart);
    //         }
    //     }
    // }


    generateRandomInteger = (x) => {
        let darr = x.no_of_balls.split('~');
        let sballno = darr[0];
        let eballno = darr[1];
        let maxballno = darr[2];
        var min = sballno;
        var max = parseInt(eballno) + 1;
        if (this.state.random.length >= maxballno) {
            this.state.random = [];
        }
        let valFound = false;
        while (valFound == false) {
            for (var i = min; i <= max; i++) {
                var temp = Math.floor(max - Math.random() * (max - min));
                //temp = ("0" + temp).slice(-2);
                temp = "" + temp;
                if (temp && this.state.random.indexOf(temp) == -1) {
                    this.state.random.push(temp);
                    valFound = true;
                    return temp;
                }
            }
        }
    };
    setIsShown = (x, flog) => {
        if (x.BetSelection && x.BetSelection.filter(a => a != '?').length == x.no_of_balls.split('~')[2]) {
            x.betComplete = flog;
        }
        else {
            x.betComplete = false;
        }
    }
    saveMyFavNo = (x) => {
        if (this.props.user == undefined || this.props.user.mobileNo == "0") {
            this.showMsg('lblplsloginTry', 1);
            return;
        }
        if (x.BetSelection.filter(a => a != '?').length != x.no_of_balls.split('~')[2]) {
            this.showMsg('lblplcurbet');
            return;
        }
        let no = (x.BetSelection.map(i => ("0" + i).slice(-2))).join(';')
        this.props.SaveMyFavNumbers(this.state.myfavNoID, this.state.currentDraw.gamegroupID, no, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
        let uObj = {};
        let SavemyNo = [x]
        commonClass.SendEventTracking(12, uObj, false, SavemyNo);
        this.setState({ myfavNoID: 0 })
        setTimeout(() => {
            this.props.GetMyFavNumbers(this.state.lottoType, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        }, 500)
    }
    setMyFavNo = (e, x) => {
        if (e.target.value == "-1") {
            this.clearCart(x)
            return;
        }
        let ss = this.state.MyFavNos[e.target.value];
        let no = ss.numbers.split(';');
        x.BetSelection = no.filter(a => a != '?').map((_no, inx) => "" + parseInt(_no));
        let darr = x.no_of_balls.split('~')[2];
        if (x.BetSelection.filter(a => a != '?').length == darr) {
            x.stakeValue = x.minStake;
        }
        else {
            x.stakeValue = 0;
        }
        this.setState({ myfavNoID: ss.favorite_id })
    }
    LoadReBetNumber = () => {
        if (this.state.currentDraw && Object.keys(this.state.currentDraw).length > 0) {
            let _no = localStorage.getItem('rebetno');
            if (_no) {
                if (_no.split("~")[0] != this.state.currentDraw.gamegroupID) {
                    localStorage.removeItem('rebetno')
                    return;
                }
                let _noArr = _no.split("~")[1]
                _noArr = _noArr.split("|")
                // let _noArr = _no.split("|")
                let len = _noArr.length - (this.state.cartItems.length);
                for (let i = 0; i < len; i++) {
                    this.createGamepad(1);
                }
                len = this.state.cartItems.length;
                for (let i = 0; i < len; i++) {
                    this.state.cartItems[i].BetSelection = _noArr[i].split(';').map(Obj => parseInt(Obj) + "");
                    this.state.cartItems[i].stakeValue = this.state.currentDraw.minStake;
                    this.state.cartItems[i].betComplete = true;
                    // Multiple Rebet issue 
                    var arr2 = JSON.stringify(this.state.cartItems[i].BetSelection);
                    arr2 = JSON.parse(arr2);
                    let sbet = [...arr2.sort((a, b) => parseInt(a) > parseInt(b) ? 1 : -1)];
                    let jnew = sbet.map((e, c) => e).join(';')
                    this.state.cartItems[i].BetSelectionSort = jnew;
                }
                localStorage.removeItem('rebetno')
            }
        }
    }
    removeGamePad = (removeinx) => {
        let updateCart = this.state.cartItems.filter((data, inx) => {
            return inx != removeinx;
        });
        this.setState({ cartItems: updateCart });

    }
    loadPrevCartItem = () => {
        if (this.state.currentDraw && Object.keys(this.state.currentDraw).length > 0) {
            //let prevCartItem = localStorage.getItem('prevCartItem') != '' ? JSON.parse(localStorage.getItem('prevCartItem')) : null;
            let prevCartItem = localStorage.getItem('mycart') != '' ? JSON.parse(localStorage.getItem('mycart')) : null;
            if (prevCartItem) {
                this.state.otherGameCount = prevCartItem.length;
                return
                //for get the other game betslip value..                
                let prevCartItem1 = prevCartItem.filter(a => a.gamegroupID != this.state.lottoType);
                this.state.otherGameCount = prevCartItem1.length;
                localStorage.setItem('mybet', JSON.stringify(prevCartItem1));
                prevCartItem = prevCartItem.filter(a => a.gamegroupID == this.state.lottoType);

                let d = []; //this.state.cartItems;
                let d1 = this.state.cartItems.pop();
                for (let i = 0; i < prevCartItem.length; i++) {
                    d.push(prevCartItem[i]);
                }
                let _maxid = this.state.cartItems.length > 0 ? Math.max(...this.state.cartItems.map(o => o.GamePadId)) : 0;
                d1.GamePadId = _maxid + 1;
                d.push(d1);
                this.setState({ cartItems: d });
                this.state.OldcartItems = prevCartItem;
            }
        }
    }
    loadSelectFavNo = () => {
        let gameNo = localStorage.getItem('setfavNo');
        gameNo = gameNo && gameNo.split('~')
        if (gameNo && gameNo[1] && this.state.cartItems && gameNo[0] == this.state.currentDraw.gamegroupID) {
            this.createGamepad(1);
            this.state.cartItems[0].BetSelection = gameNo[1].split(';').map(Obj => parseInt(Obj) + "");
            this.state.cartItems[0].stakeValue = this.state.currentDraw.minStake;
            this.state.cartItems[0].betComplete = true;
            localStorage.removeItem('setfavNo')
        }
        if (gameNo && gameNo[0] && gameNo[0] != this.state.currentDraw.gamegroupID) {
            localStorage.removeItem('setfavNo')
        }
        //add more pad
        let gameNo1 = localStorage.getItem('setAddPad');
        if (gameNo1 && this.state.cartItems && this.state.cartItems.length > 0) {
            localStorage.removeItem('setAddPad')
            this.state.cartItems[0].BetSelection = gameNo1.split(';');
            this.state.cartItems[0].stakeValue = this.state.currentDraw.minStake;
            if (this.state.cartItems[0].BetSelection && this.state.cartItems[0].BetSelection.filter(a => a != '?').length == this.state.cartItems[0].no_of_balls.split('~')[2]) {
                this.state.cartItems[0].betComplete = true;
            }
            else {
                this.state.cartItems[0].betComplete = false;
            }
            let _mycat = this.state.cartItems;
            let d = { ...this.state.cartItems[this.state.cartItems.length - 1] };
            let d1 = _mycat.pop();
            let betball = [];
            for (let i = 1; i <= d.BetSelection.length; i++) {
                betball.push('?');
            }
            d.BetSelection = betball;
            _mycat.push(d);
            let _maxid = this.state.cartItems.length > 0 ? Math.max(...this.state.cartItems.map(o => o.GamePadId)) : 0;
            d1.GamePadId = _maxid + 1;
            _mycat.push(d1);
            this.setState({ cartItems: _mycat });
        }

    }
    AboutGame = () => {
        document.getElementById('about-me').scrollIntoView({ behavior: 'smooth' });
    }

    addCustomizePad_b = (_txtthis) => {
        this.setState({ txtShow: false });
    }
    addCustomizePad_k = (_txtthis) => {
        if (/\D/g.test(_txtthis.currentTarget.value)) {
            _txtthis.currentTarget.value = _txtthis.currentTarget.value.replace(/\D/g, '');
        }
        if (this.state.padCountmax <= _txtthis.currentTarget.value) {
            _txtthis.currentTarget.value = this.state.cartItems.length - 1;
            this.state.txtPadCount = _txtthis.currentTarget.value;
        }
        else {
            this.state.txtPadCount = _txtthis.currentTarget.value;
        }
        if (0 < this.state.txtPadCount) {
            //this.state.txtPadCount = this.state.padCount;
            this.ballPadGenerate_temp();
        }
    }
    ballPadGenerate_temp = () => {
        if (this.state.txtPadCount > 0) {
            let dd = this.state.txtPadCount - (this.state.cartItems.length - 1);
            this.setState({ txtPadCount: 0 });
            if (dd > 0) {
                this.ballPadGenerate("+", dd);
            }
            else if (dd < 0) {
                this.ballPadGenerate("-", dd);
            }
        }

    }


    SelectUpcomeDraw = (x) => {
        if (this.state.myUCDraw) {
            const fobj = this.state.myUCDraw.filter(a => a == x.GameId);
            if (fobj.length > 0) {
                if (this.state.myUCDraw.length > 1)
                    this.state.myUCDraw = this.state.myUCDraw.filter(a => a != x.GameId);
            }
            else {
                let tlst = this.state.myUCDraw
                tlst.push(x.GameId);
                this.setState({ myUCDraw: tlst })
            }
        }
        else {
            this.state.myUCDraw = [x.GameId]
        }
    };

    IsvalidNumbers = (x) => {
        let darr = this.state.currentDraw.no_of_balls.split('~')[2];
        if (x.BetSelection.filter(a => a != '?').length == darr) {
            return true;
        }
        else {
            return true;
        }
    }

    ShowStatus = (Cdraw) => {
        if (Cdraw.SaleStatus == 1) {
            return `${this.props.t("lblclosed")}`
        }
        else {

        }

    }

    render() {
        console.log(this.state.cartItems)
        const { t } = this.props;
        //let gameclor = ((this.state.currentDraw && this.state.currentDraw.gamegroupID == 10) ? "bg-game-10 text-nowrap text-white" : (this.state.currentDraw && this.state.currentDraw.gamegroupID == 11) ? "bg-game11 text-nowrap text-white" : "bg-game9 text-nowrap text-white")
        // let btncolor = ((this.state.currentDraw && this.state.currentDraw.gamegroupID == 10) ? "game2BackgroundColor" : "Bg")
        // if (this.state.currentAvailableDraws && this.state.currentAvailableDraws.length > 0) {
        //     let s = this.state.currentAvailableDraws.filter(a => a.gamegroupID == this.state.lottoType);
        //     if (s.length > 0) { iSdraw = 9; }
        // }
        let IsdrawValid = this.state.currentDraw && Object.keys(this.state.currentDraw).length > 0;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" &&
                    <>
                        <LottoHelmetOthers gamegroupID={this.state.currentDraw.gamegroupID} />
                    </>
                }

                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    <div class="rht bg2 content">
                        <div class="bredCrums">
                            <ul>
                                <li><a onClick={() => { history.push('/') }}>{t('lblHome')}<img src="./assets/img/icons/right-angle.png" /></a></li>
                                <li><a class="active">{this.state.currentDraw && this.state.currentDraw.LotName}</a></li>
                            </ul>
                        </div>
                        <div class={`lottoBanner lto-${this.state.lottoType} lto-${this.state.lottoType}-bg-gradiant`}>
                            <div class="lottoLogo">
                                <img src={`./assets/img/gamesBg/${commonClass.IDWiseGameLogo(this.state.lottoType, 'others')}`} alt={`lotto logo`} className="object-fill" />
                            </div>

                            <div class="lottoPrice">
                                {this.state.currentDraw.SaleStatus == 0 && <p>{process.env.REACT_APP_CURRENCY_NAME} {this.state.currentDraw.minStake} - {this.state.currentDraw.LotName}</p>}
                                <span>&nbsp;</span>
                                {this.state.currentDraw.SaleStatus == 0 ? <h1>{process.env.REACT_APP_CURRENCY_NAME} {commonClass.aedCrnyConvert(this.state.currentDraw.RateInPs)}*</h1>
                                    : this.state.currentDraw.SaleStatus == 1 ? <h1>{t('lblclosed')} </h1> : !IsdrawValid ? <h1>{t('lblDrawClosed')}</h1> : <h1></h1>}
                            </div>
                            <div class="lottoTimer">
                                <div class="hmDateCont hmDateCont2">
                                    <div class="hmDateCoundown">
                                        {this.reCount(this.state.currentDraw)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="lottoGameSec">
                            <div class="lottoGame">
                                <div class="lottoGameLft">
                                    <div class="lottoGameLftInr">
                                        <div class="gameInfo">
                                            <img src="./assets/img/icons/vip.png" />
                                            <span>{t('lbllottowish')} </span>
                                            <p>| {t('lbllottowish2')}.</p>
                                        </div>
                                        <div class="lottoTicket">
                                            <div class="ticketTop">
                                                <span>{t('lblpick')} {IsdrawValid && this.state.currentDraw.no_of_balls.split('~')[2]} {t('lblmainum')}</span>
                                                <div>
                                                    <p>{IsdrawValid && this.state.currentDraw.BetSelection.filter(a => a != '?').length}/{IsdrawValid && this.state.currentDraw.no_of_balls.split('~')[2]}</p>
                                                    {IsdrawValid && <button onClick={() => { this.saveMyFavNo(this.state.currentDraw) }}><img src="./assets/img/icons/favorite.png" /></button>}
                                                    {IsdrawValid && <button onClick={() => { this.quickPick(this.state.currentDraw) }}><img src="./assets/img/icons/refresh-b.png" /></button>}
                                                </div>
                                            </div>
                                            <div class="formCont margin-top-20">
                                                {(this.state.MyFavNos && this.state.MyFavNos.length > 0) ?
                                                    <select value={(this.state.myfavNoID == 0 ? "-1" : this.state.myfavNoID)} onChange={(e) => this.setMyFavNo(e, this.state.currentDraw)}>
                                                        <option value="-1">{t('lblChooseFav')}</option>
                                                        {this.state.MyFavNos && this.state.MyFavNos.map((mfav, inxs) =>
                                                            <option key={`ax_${inxs}`} value={inxs}>{mfav.numbers}</option>
                                                        )}
                                                    </select> :
                                                    <select>
                                                        <option value="-1">{t('lblNoFav')}</option>
                                                    </select>}
                                            </div>

                                            <ul>
                                                {IsdrawValid && this.createBall(this.state.currentDraw)}
                                            </ul>
                                            {IsdrawValid && this.state.currentDraw.SaleStatus == 1 && <div className='tiktDrawClosed'>{t('lblclosed')}</div>}
                                            {!IsdrawValid && <div className='tiktDrawClosed'>Draw Closed...</div>}
                                            <button class="addTicketBtn active" onClick={() => { this.Addtolocalcart() }}>{t('lblAdd')}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="lottoGameRht">
                                    <div class="gameInfo floatR widthAuto">
                                        <img src="./assets/img/icons/finalise.png" />
                                        <span>{t('lblfinalpurchase')}</span>
                                    </div>
                                    <div class="lottoBetslip">
                                        <ul>
                                            {this.state.cartItems && this.state.cartItems.length > 0 && this.state.cartItems.map((x, inx) =>
                                                <li>
                                                    <span class="lottoBetslipTitle">{t('lblTicket')} - {inx + 1}</span>
                                                    <div class="lottoBetslipCont">
                                                        {x.BetSelection && x.BetSelection.length > 0 && x.BetSelection.map((y, inx) =>
                                                            <div class={`lottoBetslipBall lto-${x.gamegroupID}-border-dashed`}>{y}</div>
                                                        )}
                                                    </div>
                                                    <button onClick={() => this.removeGamePad(inx)} class="cancelBtncan"><img src="./assets/img/icons/cancel.png" /></button>
                                                </li>
                                            )}
                                        </ul>
                                        <div class="betTotal">
                                            <div class="gameInfo">
                                                <img src="./assets/img/icons/calendar.png" />
                                                {IsdrawValid && <span>{t('lblDrawDate')}: {this.state.currentDraw.DisplayDateTime}, {this.state.currentDraw.DrawShowTime}(UTC)</span>}
                                            </div>
                                            <span class="betTotalAmnt">{t('lbltotal')} {this.props.appvariables.currency} {commonClass.aedCrnyConvert(this.state.cartItems.reduce((a, b) => a = a + b.stakeValue, 0))}</span>
                                            <button class="addToCartBtn" onClick={() => { this.addMyCart() }}>{t('lblAddTocart')}</button>
                                        </div>
                                        {/* <p class="info">Your purchased bottle is donated to those in need of life’s basic amenities.</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h2 class="headding1">{t('lblAboutFooter')} {commonClass.IDWiseGameName(this.state.lottoType)}</h2>
                        {this.state.lottoType == 1 ? <Aboutplaylotto /> :
                            this.state.lottoType == 2 ? <Aboutminilotto /> :
                                this.state.lottoType == 3 ? <Aboutfastlotto /> :
                                    this.state.lottoType == 4 ? <Aboutmillionairelotto /> :
                                        this.state.lottoType == 5 ? <Aboutmultimillion /> :
                                            <Aboutsupermega />}


                        <LatestResults lottoType={this.state.lottoType} />
                        <PriceBreakdown lottoType={this.state.lottoType} />
                        <HowToPlay ispage={false} lottoType={this.state.lottoType} />


                        <div class="howToPlayVideo">
                            <iframe src="https://www.youtube.com/embed/E6_J7dFRexk?si=JSNlhr4mpHFQkx2q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <LoadFaqsLotto />
                        <LoadHomeLotto firstThreeLotto={true} lottotype={this.state.lottoType} />
                        <Footer />
                    </div >
                </div >


            </>
        );
    }
}
function mapStateToProps(state) {
    const { currentDraw, MyFavNos, previousCartItem, currentAvailableDraws } = state.gameReducer;//currentAvailableDraws // game loading performance changes.
    const { user, appvariables } = state.loginReducer;
    const { serverTime } = state.commonReducer;
    const { alertReducer } = state;
    return { user, serverTime, currentDraw, MyFavNos, appvariables, previousCartItem, alertReducer, currentAvailableDraws };
}
const mapActionToProps = {
    GameAvailableGames: gameActions.GameAvailableGames,
    closeBetSlip: gameActions.closeBetSlip,
    AddToCart: gameActions.AddToCart,
    ClearCart: gameActions.ClearCart,
    alertError: alertActions.error,
    SaveMyFavNumbers: gameActions.SaveMyFavNumbers,
    GetMyFavNumbers: gameActions.GetMyFavNumbers,
    UpdateCartAll: gameActions.UpdateCartAll,
    clearAlerts: alertActions.clear,
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Lotto))